import { render, staticRenderFns } from "./newPost.vue?vue&type=template&id=77290537&"
import script from "./newPost.vue?vue&type=script&lang=js&"
export * from "./newPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports